import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';

import queryString from 'query-string';


export default (WrappedComponent) => {
  function withSearchLocation(props) {
    const search = {};

    if (props.location && props.location.search) {
      search = queryString.parse(props.location.search)
    }

    return (
      <WrappedComponent search={search} {...props} />
    );
  }

  hoistNonReactStatic(withSearchLocation, WrappedComponent);

  return withSearchLocation;
}